import styled, { css } from 'styled-components';
import { Button } from "@m/alchemy-ui/Button";

export const StyledButton = styled(Button)`
  font-weight: 400;
`;